<template>
    <div id="container">
        <GChart id="graph"
                type="LineChart"
                :data="chartData['graph_data']"
                :options="chartOptions"
        />
        <div id="progress">
            <!--Make sure that a negative value is never obtained, 0.01 is the lowest possible value-->
            <div id="bar" v-bind:style="{height: Math.max(0.01, chartData['progress_bar_data']['current']) * 100 + '%'}"></div>
            <div id="line" v-bind:style="{bottom: chartData['progress_bar_data']['standard'] * 100 + '%'}"></div>

            <div id="adjustable-box" v-bind:style="{top: (1.000 - Math.max(0.01, chartData['progress_bar_data']['current'])) * 100 + '%'}">
                Fit<br>Index<br>{{Math.max(0.01, chartData['progress_bar_data']['current'].toFixed(3))}}
            </div>

            <div id="best-fit-box">Best<br>Fit<br>{{chartData['progress_bar_data']['standard'].toFixed(3)}}</div>
        </div>
    </div>
</template>

<script>
    import {GChart} from 'vue-google-charts'
    import {getPredictions} from "../model/model";

    export default {
        name: "Model",

        components: {
            GChart
        },

        props: ['amplitudes', 'start', 'end'],

        computed: {
            chartData: function () {
                let f1 = this.$props.amplitudes.enso;
                let f2 = this.$props.amplitudes.volc;
                let f3 = this.$props.amplitudes.sol;
                let f4 = this.$props.amplitudes.anth;
                return getPredictions(f1, f2, f3, f4);
            },

            chartOptions: function () {
                return {
                    title: 'Model Predictions',
                    legend: {position: 'in', alignment: 'start'},
                    series: {
                        0: {lineWidth: 1},
                        1: {lineWidth: 2},
                        2: {lineWidth: 2}
                    },
                    chartArea: {
                        width: '85%',
                    },
                    colors: ['black', '#4DBD51', '#D55E00'],
                    hAxis: {
                        format: "0000",
                        titleTextStyle: {fontSize: 16},
                        viewWindow: {min: this.$props.start, max: this.$props.end}
                    },
                    vAxis: {
                        viewWindow: {
                            min: -.5,
                            max: 1
                        },
                        title: 'Ta (ºC)',
                        titleTextStyle: {fontSize: 16}
                    },
                    chart: {
                        curveType: 'function',
                    }
                }
            }

        },

    }
</script>

<style scoped>
    #container {
        display: flex;
    }

    /*
    @media (min-width: 768px) {
        #container {
            height: 350px;
        }
    }

    @media (max-width: 768px) {
        #container {
            height: 200px;
        }
    }*/

    #container {
        height: 30vw;
        min-height: 200px;
    }

    #graph {
        width: 95%;
        height: 100%;
    }

    @media (max-width: 600px) {
        #progress {
            display: none;
        }
        #graph {
            width: 100%;
            height: 100%;
        }
    }


    #progress {
        position: relative;
        top: 27.5%;
        right: 1%;
        width: 3%;
        height: 50%;
        background-color: #b5b5b5;
    }

    #bar {
        position: absolute;
        bottom: 0;
        width: 100%;
        background-color: #c20000;
    }

    #line {
        position: absolute;
        width: 100%;
        height: 2px;
        background: black;
    }

    #best-fit-box {
        position: relative;
        width: 122.5%;
        height: 31%;
        bottom: 47.5%;
        left: 110%;

        background-color: #a8a8a8;
        font-size: 0.9vw;
        text-align: center;
        border: 1px solid black;
    }

    #adjustable-box {
        position: relative;
        width: 122.5%;
        height: 31%;
        left: 110%;

        background-color: #a8a8a8;
        font-size: 0.9vw;
        text-align: center;
        border: 1px solid black;
    }

</style>

